import { useCMTag } from "api/api";
import { useGlobalState } from "AppStore";
import LoadingOverlay from "components/basic/LoadingOverlay";
import moment from "moment";
import React, { useMemo, useState } from "react";
import useSiteSetup from "useSiteSetup";

const TagTesting = () => {
  useSiteSetup();
  const [tagToTest, setTagToTest] = useState("");
  const [groupingType, setGroupingType] = useState<
    "MINUTES" | "HOURS" | "DAYS" | "MONTHS" | "YEARS"
  >("MINUTES");

  const { site } = useGlobalState();
  const timeFrom = useMemo(() => moment().subtract(1, "hours"), []);
  const timeTo = useMemo(() => moment(), []);

  console.log(moment(timeFrom).format("DD-MM-YYYY HH:MM:SS"));
  console.log(moment(timeTo).format("DD-MM-YYYY"));

  // console.log({ timeFrom, timeTo });

  const { cmData: data, loading } = useCMTag(
    tagToTest,
    timeFrom.valueOf(),
    timeTo.valueOf(),
    groupingType,
    true
  );

  return (
    <div className="p-10">
      <div>
        You're on the site of: <span className="text-blue-500">{site}</span>
      </div>

      <div className="mt-10">
        <div className="mt-2 mb-4">Choose grouping type:</div>

        <div className="flex">
          <button
            className={`bg-gray-400 w-20 p-2 mr-2 ${
              groupingType === "MINUTES" && "bg-blue-400"
            }`}
            onClick={() => setGroupingType("MINUTES")}
          >
            Minutes
          </button>
          <button
            className={`bg-gray-400 w-20 p-2 mx-2 ${
              groupingType === "HOURS" && "bg-blue-400"
            }`}
            onClick={() => setGroupingType("HOURS")}
          >
            Hours
          </button>
          <button
            className={`bg-gray-400 w-20 p-2 mx-2 ${groupingType === "DAYS" && "bg-blue-400"}`}
            onClick={() => setGroupingType("DAYS")}
          >
            DAYS
          </button>
          <button
            className={`bg-gray-400 w-20 p-2 mx-2 ${
              groupingType === "MONTHS" && "bg-blue-400"
            }`}
            onClick={() => setGroupingType("MONTHS")}
          >
            MONTHS
          </button>
          <button
            className={`bg-gray-400 w-20 p-2 mx-2 ${
              groupingType === "YEARS" && "bg-blue-400"
            }`}
            onClick={() => setGroupingType("YEARS")}
          >
            YEARS
          </button>
        </div>

        <div className="mt-10">
          Insert the name of a tag to check for results (if no results are loaded, we can't get
          data from that tag)
        </div>
        <input
          type="text"
          name="testTag"
          id="testTag"
          placeholder="Tag text"
          className="border-2 p-1 border-gray-400"
          onChange={(e) => {
            setTagToTest(e.target.value);
          }}
        />

        <div className="mt-10">Results:</div>
        {data && (
          <div>
            <ul>
              {data.points.map((point, i) => (
                <li className="text-sm" key={i}>{`${moment(point.time).format(
                  "DD-MM-YYYY HH:MM:SS"
                )}:  ${point.value}`}</li>
              ))}
            </ul>
          </div>
        )}
        {loading && <LoadingOverlay />}
      </div>
    </div>
  );
};

export default TagTesting;
